<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Target</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">

                    <div class="col-12">
                      <label class="align-middle">Appraisal Period <span class="required">*</span></label>
                      <AsyncSelect
                          placeholder="Select Appraisal Period"
                          v-model="apprisalSetup"
                          :autoSelectFirst="true"
                          :api-service="fetchPerformanceApprisalSetupDropdown"
                      />
                    </div>

                    <div class="col-12 pt-2">
                      <div class="bg-light border-bottom p-1">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <h5 class="mb-0 fw-bold">{{ targetComponentData.name }}</h5>
                          </div>
                        </div>
                      </div>
                      <div class="row p-2">
                        <div class="col-12 mb-3 mb-lg-0">
                          <TreeTargetComponentItem
                              v-for="item in targetComponentData.active_child"
                              :key="item.name"
                              :parent="targetComponentData"
                              :node="item"
                          />
                        </div>
                      </div>
                    </div>
                    <hr>

                      <div class="mt-1 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-1">
                        <button :disabled="loading"
                                @click="submit"
                                class="btn btn-primary">

                          <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          Save
                        </button>
                        <button @click="onClickClose" class="btn btn-outline-secondary">Cancel</button>
                      </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { inject, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import TreeTargetComponentItem from '@/components/molecule/company/hrm-payroll/performance-appraisal/TreeTargetComponentItem.vue';

const props = defineProps({
   targetComponent:{
      type:Object,
      default:{}
    },
    contactProfileId:{
       default:null
    },
    isSupervisor:{
       default: false,
       type: Boolean
    },
    isList: {
      type: Boolean,
      default: false
    },
});

const emit = defineEmits(['getApprisalData']);
const $store = useStore();
const route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = ref(false);
const apprisalSetup = ref('')
const performanceComponentSetupId = ref('')
const contactProfile = ref('');
const targetComponentData = ref({});
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
import handleDropDown from "@/services/modules/dropdowns";

const {
  createTargetAchievement,
  fetchTargetAchievementComponent
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact();
const { fetchPerformanceApprisalSetupDropdown } = handleDropDown();

const submit = () => {
  const components = extractComponent(targetComponentData.value)
  let apprisalData = {};
  apprisalData.components = components;
  apprisalData.company_id = route.params.companyId;
  apprisalData.type = 'target';
  apprisalData.performance_apprisal_setup_id = apprisalSetup.value.id;
  apprisalData.performance_component_setup_id = performanceComponentSetupId.value;
  if (props.contactProfileId){
    apprisalData.user_contact_profile_id = props.contactProfileId;
  }
  if (props.isSupervisor){
    apprisalData.is_supervisor = 1;
  }

  let query = `?company_id=${route.params.companyId}`;
  loading.value = true;
  createTargetAchievement(apprisalData, query)
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        emit('getApprisalData')
        onClickClose()
        showSuccess(res.message)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
    loading.value = false
  })
}

const extractComponent = (node) => {
  const endpoints = []
  const traverse = (n) => {
    if (n.type === 'endpoint') {
      endpoints.push({
        performance_component_setup_id: n.id,
        qty: n.qty ? n.qty : null,
        value: n.value ? n.value : 0,
        remarks: n.remarks ? n.remarks : 0,
      })
    }
    if (n.active_child && n.active_child.length) {
      n.active_child.forEach(traverse)
    }
  }
  traverse(node)
  return endpoints
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}&is_list=${(props.isList === true ? 1 : 0)}`;
  if(apprisalSetup.value) query += `&performance_apprisal_setup_id=` + apprisalSetup.value.id;
  if(performanceComponentSetupId.value) query += `&performance_component_setup_id=` + performanceComponentSetupId.value;
  if (props.contactProfileId) query += `&user_contact_profile_id=` + props.contactProfileId;
  return query;
}

const getTargetComponentData = async () => {
  const query = getQuery();
  loading.value = true
  targetComponentData.value = {};
  await fetchTargetAchievementComponent(query).then(res => {
    if (!res.status){
      return
    }
    targetComponentData.value = res.data.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

watch([() => props.targetComponent, apprisalSetup], ([target, setup]) => {
  if (!target.id || !setup.id) return;
  performanceComponentSetupId.value = target.id;
  getTargetComponentData();
}, { immediate: true });

</script>
